import { COLORS, MD_PERMISSIONS, DEFAULT_OPERATOR_PERMISSIONS, PERMISSION_LABELS } from "../../shared/constants";
import { IconEdit, IconPlus } from "../../shared/icons";
import { useState } from "react";

export default // ─── Users Tab ────────────────────────────────────
function UsersTab({ users, onSave, onDeactivate, isMD }) {
  const [editing, setEditing] = useState(null);
  const [confirmDeactivate, setConfirmDeactivate] = useState(null);
  const activeUsers = users.filter((u) => u.is_active !== false);
  const inactiveUsers = users.filter((u) => u.is_active === false);

  const UserForm = ({ user, onDone }) => {
    const [f, setF] = useState({ first_name: user?.first_name || "", last_name: user?.last_name || "", email: user?.email || "", pin: "", role: user?.role || "OPERATOR" });
    const [perms, setPerms] = useState(user?.permissions || { ...DEFAULT_OPERATOR_PERMISSIONS });
    const showPerms = f.role === "OPERATOR";
    return (
      <div style={{ padding: "14px", background: COLORS.primaryLight, borderRadius: "8px", marginBottom: "12px" }}>
        <div style={{ fontSize: "13px", fontWeight: "700", color: COLORS.primary, marginBottom: "10px" }}>{user ? "Edit User" : "New User"}</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: "8px", marginBottom: "8px" }}>
          <input style={{ height: "36px", padding: "0 10px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, fontSize: "13px" }} value={f.first_name} onChange={(e) => setF((p) => ({ ...p, first_name: e.target.value }))} placeholder="First name" />
          <input style={{ height: "36px", padding: "0 10px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, fontSize: "13px" }} value={f.last_name} onChange={(e) => setF((p) => ({ ...p, last_name: e.target.value }))} placeholder="Last name" />
          <input style={{ height: "36px", padding: "0 10px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, fontSize: "13px" }} value={f.email} onChange={(e) => setF((p) => ({ ...p, email: e.target.value }))} placeholder="Email" />
          <input type="password" style={{ height: "36px", padding: "0 10px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, fontSize: "13px" }} value={f.pin} onChange={(e) => setF((p) => ({ ...p, pin: e.target.value }))} placeholder={user ? "New PIN (leave blank)" : "6-digit PIN"} maxLength={6} />
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: showPerms ? "12px" : "0" }}>
          <select style={{ height: "36px", padding: "0 10px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, fontSize: "13px" }} value={f.role} onChange={(e) => {
            setF((p) => ({ ...p, role: e.target.value }));
            if (e.target.value === "MD") setPerms({ ...MD_PERMISSIONS });
            else if (!user?.permissions) setPerms({ ...DEFAULT_OPERATOR_PERMISSIONS });
          }}>
            <option value="OPERATOR">Operator</option>
            <option value="MD">MD</option>
          </select>
          <button onClick={() => { onSave({ ...user, ...f, pin: f.pin || user?.pin, is_active: true, permissions: f.role === "MD" ? { ...MD_PERMISSIONS } : perms }); onDone(); }}
            style={{ height: "36px", padding: "0 16px", borderRadius: "6px", border: "none", background: COLORS.primary, color: "#FFF", fontSize: "12px", fontWeight: "600", cursor: "pointer" }}>
            Save
          </button>
          <button onClick={onDone} style={{ height: "36px", padding: "0 16px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, background: "transparent", color: COLORS.textSecondary, fontSize: "12px", fontWeight: "500", cursor: "pointer" }}>Cancel</button>
          {showPerms && (
            <div style={{ marginLeft: "auto", display: "flex", gap: "6px" }}>
              <button onClick={() => setPerms({ ...MD_PERMISSIONS })} style={{ height: "28px", padding: "0 10px", borderRadius: "6px", border: `1px solid ${COLORS.accent}`, background: "#E8F8F0", color: COLORS.accent, fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>All On</button>
              <button onClick={() => setPerms({ ...DEFAULT_OPERATOR_PERMISSIONS })} style={{ height: "28px", padding: "0 10px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, background: COLORS.surface, color: COLORS.textSecondary, fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>Defaults</button>
              <button onClick={() => {
                const allOff = {};
                Object.keys(DEFAULT_OPERATOR_PERMISSIONS).forEach((k) => { allOff[k] = false; });
                setPerms(allOff);
              }} style={{ height: "28px", padding: "0 10px", borderRadius: "6px", border: `1px solid ${COLORS.dangerBorder}`, background: COLORS.dangerLight, color: COLORS.danger, fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>All Off</button>
            </div>
          )}
        </div>
        {showPerms && (
          <div style={{ background: COLORS.surface, borderRadius: "8px", border: `1px solid ${COLORS.border}`, padding: "12px" }}>
            <div style={{ fontSize: "11px", fontWeight: "700", color: COLORS.textSecondary, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "10px" }}>
              Operator Permissions
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px" }}>
              {Object.entries(PERMISSION_LABELS).map(([key, label]) => (
                <label key={key} style={{ display: "flex", alignItems: "center", gap: "8px", padding: "6px 8px", borderRadius: "6px", cursor: "pointer", fontSize: "12px", color: COLORS.text, background: perms[key] ? "#E8F8F0" : "transparent" }}>
                  <div onClick={() => setPerms((p) => ({ ...p, [key]: !p[key] }))}
                    style={{
                      width: "36px", height: "20px", borderRadius: "10px", position: "relative",
                      background: perms[key] ? COLORS.accent : COLORS.border, cursor: "pointer",
                      transition: "background 0.2s", flexShrink: 0,
                    }}>
                    <div style={{
                      width: "16px", height: "16px", borderRadius: "50%", background: "#FFF",
                      position: "absolute", top: "2px", left: perms[key] ? "18px" : "2px",
                      transition: "left 0.2s", boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                    }} />
                  </div>
                  <span style={{ fontWeight: perms[key] ? "500" : "400", color: perms[key] ? COLORS.text : COLORS.textSecondary }}>{label}</span>
                </label>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
        <h3 style={{ fontSize: "16px", fontWeight: "600", color: COLORS.text, margin: 0 }}>User Management</h3>
        {isMD && <button onClick={() => setEditing("NEW")} style={{ height: "36px", padding: "0 16px", borderRadius: "8px", border: "none", background: COLORS.accent, color: "#FFF", fontSize: "13px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", gap: "4px" }}><IconPlus /> Add User</button>}
      </div>
      {!isMD && <div style={{ padding: "12px", background: COLORS.warningLight, borderRadius: "8px", marginBottom: "16px", fontSize: "13px", color: COLORS.warning }}>User management is restricted to the MD role.</div>}
      {editing === "NEW" && <UserForm onDone={() => setEditing(null)} />}
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            {["Name", "Email", "Role", "Status", "Actions"].map((h) => (
              <th key={h} style={{ padding: "10px 12px", textAlign: "left", fontSize: "11px", fontWeight: "600", color: COLORS.textSecondary, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: `2px solid ${COLORS.border}` }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {activeUsers.map((u) => (
            <tr key={u.id} style={{ borderBottom: `1px solid ${COLORS.borderLight}` }}>
              {editing === u.id ? (
                <td colSpan={5} style={{ padding: "8px 0" }}><UserForm user={u} onDone={() => setEditing(null)} /></td>
              ) : (
                <>
                  <td style={{ padding: "12px", fontSize: "14px", fontWeight: "500", color: COLORS.text }}>{u.first_name} {u.last_name}</td>
                  <td style={{ padding: "12px", fontSize: "13px", color: COLORS.textSecondary }}>{u.email || "—"}</td>
                  <td style={{ padding: "12px" }}>
                    <span style={{ padding: "2px 8px", borderRadius: "4px", fontSize: "11px", fontWeight: "600", background: u.role === "MD" ? "#E8F8F0" : COLORS.primaryLight, color: u.role === "MD" ? COLORS.accent : COLORS.primary }}>{u.role}</span>
                  </td>
                  <td style={{ padding: "12px" }}><span style={{ fontSize: "12px", color: COLORS.accent }}>Active</span></td>
                  <td style={{ padding: "12px" }}>
                    {isMD && (
                      <div style={{ display: "flex", gap: "4px" }}>
                        <button onClick={() => setEditing(u.id)} style={{ height: "28px", padding: "0 8px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, background: COLORS.surface, color: COLORS.primary, fontSize: "11px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", gap: "3px" }}><IconEdit /> Edit</button>
                        {confirmDeactivate === u.id ? (
                          <div style={{ display: "flex", gap: "3px", alignItems: "center" }}>
                            <span style={{ fontSize: "11px", color: COLORS.danger, fontWeight: "600" }}>Deactivate?</span>
                            <button onClick={() => { onDeactivate(u.id); setConfirmDeactivate(null); }} style={{ height: "28px", padding: "0 8px", borderRadius: "6px", border: "none", background: COLORS.danger, color: "#FFF", fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>Yes</button>
                            <button onClick={() => setConfirmDeactivate(null)} style={{ height: "28px", padding: "0 8px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, background: COLORS.surface, color: COLORS.textSecondary, fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>No</button>
                          </div>
                        ) : (
                          <button onClick={() => setConfirmDeactivate(u.id)} style={{ height: "28px", padding: "0 8px", borderRadius: "6px", border: `1px solid ${COLORS.dangerBorder}`, background: COLORS.dangerLight, color: COLORS.danger, fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>Deactivate</button>
                        )}
                      </div>
                    )}
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      {inactiveUsers.length > 0 && (
        <div style={{ marginTop: "20px" }}>
          <div style={{ fontSize: "12px", fontWeight: "600", color: COLORS.textSecondary, marginBottom: "8px" }}>Deactivated Users</div>
          {inactiveUsers.map((u) => (
            <div key={u.id} style={{ padding: "8px 12px", background: COLORS.inputBg, borderRadius: "6px", marginBottom: "4px", fontSize: "13px", color: COLORS.textSecondary, display: "flex", justifyContent: "space-between" }}>
              <span>{u.first_name} {u.last_name} — {u.role}</span>
              <span style={{ fontSize: "11px" }}>Deactivated</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Providers Tab ────────────────────────────────

